export const normalizeFeatureSet = (value: unknown): string | null => {
    if (typeof value !== "string") {
        return null;
    }

    const normalized = value.trim().toLowerCase();
    return normalized || null;
};

export const isFreeTrialFeatureSet = (value: unknown): boolean => normalizeFeatureSet(value) === "free_trial";

export const formatFeatureSetLabel = (value: unknown): string => {
    const normalized = normalizeFeatureSet(value);
    const formattedFeatureSet = (normalized ?? "").replace(/[_-]+/g, " ").trim();
    const baseLabel =
        formattedFeatureSet.length > 0
            ? formattedFeatureSet
                  .split(/\s+/)
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ")
            : "-";

    return `${baseLabel}`;
};
